module.exports = __webpack_public_path__ + "img/picto-tab-mental.2be2e233.svg";